import React, { Component } from "react";
import { connect } from "react-redux";

import moment from "moment";
import { Navigate } from "react-router-dom";
import _ from "lodash";

import {
  fetchItems,
  fetchItemsSuccess,
  fetchItemsFailure,
  fetchBrands,
  fetchBrandsSuccess,
  fetchBrandsFailure,
  fetchGrades,
  fetchGradesSuccess,
  fetchGradesFailure,
} from "../../store/inventories/actions";
import {
  fetchPurchaseOrderDetail,
  fetchPurchaseOrderDetailSuccess,
  fetchPurchaseOrderDetailFailure,
} from "../../store/purchaseOrders/actions";

import {
  addItemToPurchaseOrder,
  deleteItemFromPurchaseOrder,
  updateItemInPurchaseOrder,
  awaitPurchaseOrder,
  duplicatePurchaseOrder,
  deletePurchaseOrder,
  completePurchaseOrder,
} from "../../store/purchaseOrders/api";
import { getItems } from "../../store/inventories/api";

import { purchaseOrderStatusOptions, purchaseOrderTransportConditions } from "../../utils/Helpers";
import { isMarketUser } from "../../utils/AuthService";
import Alert from "../../utils/Alert";
import Modal from "../../components/generics/Modal";

import Spinner from "../../components/generics/Spinner";
import PurchaseOrderDetail from "../../components/purchaseOrders/PurchaseOrderDetail";
import PurchaseOrderByPriceDetail from "../../components/purchaseOrders/byPriceComponents/PurchaseOrderByPriceDetail";
import PurchaseOrderDetailHeader from "../../components/purchaseOrders/PurchaseOrderDetailHeader";
import PurchaseOrderInputBox from "../../components/purchaseOrders/PurchaseOrderInputBox";
import PurchaseOrderPrint from "../../components/purchaseOrders/PurchaseOrderPrint";
import { withRouter } from "utils/WithRouter";

export class PurchaseOrderDetailContainer extends Component {
  constructor(props) {
    super(props);
    this.alertRef = React.createRef();

    this.state = {
      isLoadingItems: false,
      selectedItem: {
        item: undefined,
        item_index: -1,
        item_info: null,
        quantity: "",
        presentation: undefined,
        brand: -1,
        has_grade: false,
        grade: -1,
        numberItems: "",
        price: "",
      },
      itemsList: [],
      editingItem: false,
      errors: [],
      openDeleteModal: false,
      deliveryDate: "",
      deliveryDateError: false,
    };
  }

  componentDidMount() {
    this.props.fetchPurchaseOrderDetail(this.props.match.params.id);
    this.props.filterItems();
    this.props.fetchBrands();
    this.props.fetchGrades();
  }

  spliceError = (element) => {
    let errors = this.state.errors.slice();
    const index = errors.indexOf(element);
    if (index !== -1) {
      errors.splice(index, 1);
    }
    return errors;
  };

  onFinishLoading = () => {
    this.setState({ isLoadingItems: false });
  };

  searchItems = (input, callback) => {
    this.setState({ isLoadingItems: true });
    let options = [];
    getItems(input, null, null, null, this.props.purchaseOrder.purchaseOrder.vendor.id, true)
      .then((r) => {
        this.setState({ itemsList: r.data }, this.onFinishLoading);
        // eslint-disable-next-line array-callback-return
        r.data.results.map((item) => {
          options.push({ value: item.id, label: item.name });
        });
        callback(options);
      })
      .catch((err) => {
        this.setState({ isLoadingItems: false });
        console.log(err);
      });
  };

  handlePurchaseOrderSubmit = () => {
    const purchaseOrderId = this.props.match.params.id;
    const deliveryDate = this.state.deliveryDate;
    const deliveryDateError = !deliveryDate || this.state.deliveryDateError;
    if (!deliveryDateError)
      if (isMarketUser()) {
        completePurchaseOrder(purchaseOrderId, { delivery_date: deliveryDate }).then(() => {
          // Refresh Purchase Order
          this.props.fetchPurchaseOrderDetail(purchaseOrderId);
          this.alertRef.current.sendAlert("Your purchase order has been successfully sent", "success");
        });
      } else {
        awaitPurchaseOrder(purchaseOrderId, { delivery_date: deliveryDate }).then(() => {
          // Refresh Purchase Order
          this.props.fetchPurchaseOrderDetail(purchaseOrderId);
          this.alertRef.current.sendAlert("Your purchase order has been successfully sent", "success");
        });
      }
    else this.setState({ deliveryDateError });
  };

  handleAssociateInvoiceSubmit = () => {
    const purchaseOrderId = this.props.match.params.id;
    this.props.history.push(`/purchase_orders/${purchaseOrderId}/invoice`);
  };

  handleNewInvoiceSubmit = () => {
    const purchaseOrderId = this.props.match.params.id;
    this.props.history.push(`/purchase_orders/${purchaseOrderId}/invoice_create`);
  };

  handleSeeLabels = () => {
    const invoiceId = this.props.purchaseOrder.purchaseOrder.invoice.id;
    this.props.history.push(`/invoice/${invoiceId}/labels`);
  };

  handleDuplicate = () => {
    const purchaseOrderId = this.props.match.params.id;
    duplicatePurchaseOrder(purchaseOrderId).then(
      (response) => {
        const newPOId = response.data.id;
        this.props.fetchPurchaseOrderDetail(newPOId);
        this.alertRef.current.sendAlert("Purchase Order was duplicated successfully", "success");
        this.props.history.push(isMarketUser() ? `/purchase_orders_by_price/new/` : `/purchase_orders/${newPOId}/`);
      },
      () => {
        this.alertRef.current.sendAlert("Could not duplicate the Purchase Order");
      }
    );
  };

  handleDuplicateByPrice = () => {
    const purchaseOrderId = this.props.match.params.id;
    duplicatePurchaseOrder(purchaseOrderId).then(
      (response) => {
        const newPOId = response.data.id;
        this.alertRef.current.sendAlert("Purchase Order was duplicated successfully", "success");
        this.props.history.push(`/purchase_orders_by_price/${newPOId}/`);
      },
      () => {
        this.alertRef.current.sendAlert("Could not duplicate the Purchase Order");
      }
    );
  };

  handleItemChange = (event) => {
    let selectedItem = this.state.selectedItem;
    if (event === null || event.value === undefined) {
      selectedItem.item = undefined;
      selectedItem.item_index = -1;
      selectedItem.has_grade = false;
      selectedItem.grade = -1;
      selectedItem.numberItems = "";
      this.setState({ selectedItem });
    } else {
      const item_index = _.findIndex(this.state.itemsList.results, function (o) {
        return o.id === event.value;
      });
      const item = this.state.itemsList.results[item_index];
      selectedItem.item = item;
      selectedItem.item_info = { value: item.id, label: item.name };
      selectedItem.item_index = item.id;
      selectedItem.presentation = item.master_packing_type;
      selectedItem.numberItems = item.master_packing_number ? item.master_packing_number : "";
      if (!item.has_grade) {
        selectedItem.grade = -1;
      }
      selectedItem.has_grade = item.has_grade;
      this.setState({ selectedItem, errors: [] });
    }
  };

  handleQuantityChange = (event) => {
    let selectedItem = this.state.selectedItem;
    selectedItem.quantity = event.target.value;
    let errors = this.state.errors.slice();
    const index_error = errors.indexOf("quantity");
    //check if quantity is an integer and positive value
    if (!selectedItem.quantity || selectedItem.quantity <= 0) {
      if (index_error === -1) {
        errors.push("quantity");
      }
    } else {
      if (index_error !== -1) {
        errors = this.spliceError("quantity");
      }
    }
    this.setState({ selectedItem, errors });
  };

  handleBrandChange = (event) => {
    let selectedItem = this.state.selectedItem;
    selectedItem.brand = Number(event.target.value);
    const errors = this.spliceError("brand");
    this.setState({ selectedItem, errors });
  };

  handleGradeChange = (event) => {
    let selectedItem = this.state.selectedItem;
    selectedItem.grade = Number(event.target.value);
    const errors = this.spliceError("grade");
    this.setState({ selectedItem, errors });
  };

  handleNumberItemsChange = (event) => {
    let selectedItem = this.state.selectedItem;
    selectedItem.numberItems = event.target.value;
    let errors = this.state.errors.slice();
    const index_error = errors.indexOf("numberItems");
    //check if the number of items is an integer and positive value
    if (selectedItem.numberItems && selectedItem.numberItems <= 0) {
      if (index_error === -1) {
        errors.push("numberItems");
      }
    } else {
      if (index_error !== -1) {
        errors = this.spliceError("numberItems");
      }
    }
    this.setState({ selectedItem, errors });
  };

  handlePriceChange = () => {
    let selectedItem = this.state.selectedItem;
    let errors = this.state.errors.slice();
    const index_error = errors.indexOf("price");
    //check if price is an integer and positive value
    if (!selectedItem.price || selectedItem.price <= 0) {
      if (index_error === -1) {
        errors.push("price");
      }
    } else {
      if (index_error !== -1) {
        errors = this.spliceError("price");
      }
    }
    this.setState({ errors });
  };

  onPriceChange = (event) => {
    let selectedItem = this.state.selectedItem;
    selectedItem.price = event.target.value;
    let errors = this.state.errors.slice();
    errors = this.spliceError("price");
    this.setState({ selectedItem, errors });
  };

  errorCheck = ({ item_index, brand, numberItems, quantity, price, has_grade, grade }) => {
    let errors = [];
    let index;
    if (item_index !== -1 && brand !== -1 && (!numberItems || numberItems > 0) && quantity && quantity > 0 && price && price > 0) {
      if (has_grade && grade === -1) {
        errors = this.state.errors.slice();
        index = errors.indexOf("grade");
        if (index === -1) {
          errors.push("grade");
        }
        this.alertRef.current.sendAlert("All fields are required!");
        this.setState({ errors });
      }
    } else {
      errors = this.state.errors.slice();
      if (item_index === -1) {
        index = errors.indexOf("item");
        if (index === -1) {
          errors.push("item");
        }
      }
      if (brand === -1) {
        index = errors.indexOf("brand");
        if (index === -1) {
          errors.push("brand");
        }
      }
      if (has_grade && grade === -1) {
        index = errors.indexOf("grade");
        if (index === -1) {
          errors.push("grade");
        }
      }
      if (numberItems && numberItems <= 0) {
        index = errors.indexOf("numberItems");
        if (index === -1) {
          errors.push("numberItems");
        }
      }
      if (!quantity || quantity <= 0) {
        index = errors.indexOf("quantity");
        if (index === -1) {
          errors.push("quantity");
        }
      }
      if (!price || price <= 0) {
        index = errors.indexOf("price");
        if (index === -1) {
          errors.push("price");
        }
      } else {
        this.alertRef.current.sendAlert("All fields are required!");
      }
      this.setState({ errors });
    }
    return errors;
  };

  addItemToPurchaseOrder = (item) => {
    const { item_index, quantity, brand, has_grade, grade, numberItems, price } = item;
    addItemToPurchaseOrder(this.props.match.params.id, {
      item: item_index,
      quantity: quantity,
      brand: brand,
      grade: has_grade ? grade : null,
      number_items: numberItems ? numberItems : 1,
      number_inventories: quantity,
      price: price,
    }).then(
      (response) => {
        this.alertRef.current.sendAlert(`${item.item.name} has been added to the purchase order`, "success");
        // Refresh Purchase Order
        this.props.fetchPurchaseOrderDetail(this.props.match.params.id);
        this.setState({ errors: [] });
      },
      () => {
        this.alertRef.current.sendAlert("The item could not be added.");
      }
    );
  };

  addItem = () => {
    this.setState({ submitting: true });
    let selectedItem = this.state.selectedItem;
    const errors = this.errorCheck(selectedItem);
    if (!errors.length) {
      this.addItemToPurchaseOrder(selectedItem);
      this.setState({
        selectedItem: {
          item: undefined,
          item_index: -1,
          item_info: null,
          quantity: "",
          presentation: undefined,
          brand: -1,
          has_grade: false,
          grade: -1,
          numberItems: "",
          price: "",
        },
      });
    }
    this.setState({ submitting: false });
  };

  handleDeleteItem = (id) => {
    deleteItemFromPurchaseOrder(id).then(
      () => {
        // Refresh Purchase Order
        this.props.fetchPurchaseOrderDetail(this.props.match.params.id);
        this.alertRef.current.sendAlert("Item was successfully removed from the purchase order", "success");
      },
      () => {
        this.alertRef.current.sendAlert("The item could not be deleted");
      }
    );
  };

  clearSelectedItem = () => {
    this.setState({
      selectedItem: {
        item: undefined,
        item_index: -1,
        item_info: null,
        quantity: "",
        presentation: undefined,
        brand: -1,
        has_grade: false,
        grade: -1,
        numberItems: "",
        price: "",
      },
      errors: [],
      editingItem: false,
    });
  };

  handleEditItem = (item) => {
    this.setState({
      selectedItem: {
        item: item.name,
        item_index: item.id,
        item_info: { value: item.id, label: item.name },
        quantity: item.quantity,
        presentation: item.presentation,
        brand: item.brand.id,
        has_grade: item.grade !== null,
        grade: item.grade ? item.grade.id : -1,
        numberItems: item.number_items,
        price: item.price,
      },
      editingItem: true,
      errors: [],
    });
  };

  updateItemInPurchaseOrder = (item) => {
    const { item: item_name, item_index, quantity, brand, has_grade, grade, numberItems, price } = item;
    updateItemInPurchaseOrder(item_index, {
      purchase_order: this.props.match.params.id,
      quantity: quantity,
      brand: brand,
      grade: has_grade ? grade : null,
      number_items: numberItems ? numberItems : 1,
      number_inventories: quantity,
      price: price,
    }).then(
      (response) => {
        this.alertRef.current.sendAlert(`${item_name} has been updated!`, "success");
        // Refresh Purchase Order
        this.props.fetchPurchaseOrderDetail(this.props.match.params.id);
        this.setState({ errors: [] });
      },
      () => {
        this.alertRef.current.sendAlert("The item could not be updated");
      }
    );
  };

  updateItem = () => {
    this.setState({ updating: true });
    let selectedItem = this.state.selectedItem;
    const errors = this.errorCheck(selectedItem);
    if (!errors.length) {
      this.updateItemInPurchaseOrder(selectedItem);
      this.setState({
        selectedItem: {
          item: undefined,
          item_index: -1,
          item_info: null,
          quantity: "",
          presentation: undefined,
          brand: -1,
          has_grade: false,
          grade: -1,
          numberItems: "",
          price: "",
        },
        editingItem: false,
      });
    }
  };

  onPrint = () => {
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    var content = document.getElementById(`poPrint${this.props.match.params.id}`);
    pri.document.write(content.innerHTML);
    pri.document.close();
    setTimeout(() => {
      pri.focus();
      pri.print();
    }, 50);
  };

  handleDeleteModal = () => {
    this.setState({ openDeleteModal: true });
  };

  handleDelete = () => {
    const purchaseOrderId = this.props.match.params.id;
    deletePurchaseOrder(purchaseOrderId).then(
      () => {
        this.alertRef.current.sendAlert(`Purchase Order #${purchaseOrderId} has been deleted successfully`, "success");
        this.props.history.push("/purchase_orders");
      },
      () => {
        this.alertRef.current.sendAlert(`Purchase Order #${purchaseOrderId} couldn't be deleted`);
      }
    );
    this.setState({ openDeleteModal: false });
  };

  handleDeliveryDate = (event) => {
    let now = moment().format("YYYY-MM-DD");
    let deliveryDate = event.target.value ? moment(event.target.value).format("YYYY-MM-DD") : "";
    let deliveryDateError = deliveryDate && now > deliveryDate;
    this.setState({ deliveryDate, deliveryDateError });
  };

  

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    const { purchaseOrder, loading, error } = this.props.purchaseOrder;
    const { itemsList, brandsList, gradesList } = this.props;
    const { selectedItem, editingItem } = this.state;
    if (!purchaseOrder && !loading && error) {
      return <Navigate to="/purchase_orders" />;
    }

    if (!purchaseOrder) {
      return (
        <div>
          <Alert ref={this.alertRef} />
          <Spinner />
        </div>
      );
    }

    if (purchaseOrder.id === Number(this.props.match.params.id) && purchaseOrder.status === 1 && purchaseOrder.invoice) {
      return (
        <Navigate
          to={`/purchase_orders/${this.props.match.params.id}/invoice`}
        />
      );
    }

    const date = purchaseOrder ? moment(purchaseOrder.date).format("L") : "";
    const transportCondition_index = _.findIndex(purchaseOrderTransportConditions, function (o) {
      return o.id === purchaseOrder.transport_condition;
    });

    const styleFrame = {
      height: "0px",
      width: "0px",
      position: "absolute",
      display: "none",
    };

    return (
      <div className="animated fadeIn">
        <Alert ref={this.alertRef} />
        <Modal
          closeModal={() => this.setState({ openDeleteModal: false })}
          isModalOpen={this.state.openDeleteModal}
          onConfirm={() => this.handleDelete()}
          onCancel={() => this.setState({ openDeleteModal: false })}
          header="Delete Purchase Order"
          content={`Are you sure you want to delete Purchase Order #${this.props.match.params.id}?`}
          onConfirmButtonText="Yes"
          onCancelButtonText="No"
        />
        <PurchaseOrderDetailHeader
          purchaseOrderId={purchaseOrder.id}
          purchaseOrderVendor={purchaseOrder.vendor.name}
          purchaseOrderDate={date}
          purchaseOrderDeliveryDate={purchaseOrder.delivery_date}
          status={purchaseOrderStatusOptions[purchaseOrder.status]}
          handlePurchaseOrderSubmit={this.handlePurchaseOrderSubmit}
          handleAssociateInvoiceSubmit={this.handleAssociateInvoiceSubmit}
          handleNewInvoiceSubmit={this.handleNewInvoiceSubmit}
          handlePrint={this.onPrint}
          handleSeeLabels={this.handleSeeLabels}
          handleDuplicate={this.handleDuplicate}
          handleDuplicateByPrice={this.handleDuplicateByPrice}
          transportCondition={purchaseOrderTransportConditions[transportCondition_index].name}
          handleDelete={this.handleDeleteModal}
          deliveryDate={this.state.deliveryDate}
          deliveryDateError={this.state.deliveryDateError}
          handleDeliveryDate={this.handleDeliveryDate}
          isFromMarket={purchaseOrder.is_from_market}
        />
        {purchaseOrder.status !== 2 && (
          <PurchaseOrderInputBox
            editingItem={editingItem}
            item={selectedItem.item_index}
            selectedItem={selectedItem.item_info}
            itemName={selectedItem.item}
            items={itemsList.items.results}
            onItemChange={this.handleItemChange}
            quantity={selectedItem.quantity}
            presentation={selectedItem.presentation}
            onQuantityChange={this.handleQuantityChange}
            brand={selectedItem.brand}
            brands={brandsList.brands.results}
            onBrandChange={this.handleBrandChange}
            hasGrade={selectedItem.has_grade}
            grade={selectedItem.grade}
            grades={gradesList.grades.results}
            onGradeChange={this.handleGradeChange}
            numberItems={selectedItem.numberItems}
            onNumberItemsChange={this.handleNumberItemsChange}
            price={selectedItem.price}
            onPriceChange={this.onPriceChange}
            handlePriceChange={this.handlePriceChange}
            addItem={this.addItem}
            updateItem={this.updateItem}
            cancelEditItem={this.clearSelectedItem}
            isLoadingItems={itemsList.loading}
            searchItems={this.searchItems}
            errors={this.state.errors}
          />
        )}
        {purchaseOrder.is_from_market ? (
          <PurchaseOrderByPriceDetail purchaseOrder={purchaseOrder} marketDetail />
        ) : (
          <PurchaseOrderDetail
            purchaseOrder={purchaseOrder}
            handleEditItem={this.handleEditItem}
            handleDeleteItem={this.handleDeleteItem}
          />
        )}

        {loading ? <Spinner /> : null}
        {/* Print */}
        <PurchaseOrderPrint
          poId={purchaseOrder.id}
          vendor={purchaseOrder.vendor.name}
          createdBy={purchaseOrder.created_by}
          date={purchaseOrder.date}
          items={purchaseOrder.items}
          status={purchaseOrder.status}
        />
        <iframe id="ifmcontentstoprint" style={styleFrame}></iframe>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    purchaseOrder: state.purchaseOrders.purchaseOrderDetail,
    itemsList: state.inventories.itemsList,
    brandsList: state.inventories.brandsList,
    gradesList: state.inventories.gradesList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPurchaseOrderDetail: (id) => {
      dispatch(fetchPurchaseOrderDetail(id)).payload.then(
        (response) => {
          dispatch(fetchPurchaseOrderDetailSuccess(response.data));
        },
        (error) => {
          dispatch(fetchPurchaseOrderDetailFailure(error));
        }
      );
    },
    filterItems: (query, station, page) => {
      dispatch(fetchItems(query, station, page)).payload.then(
        (response) => {
          dispatch(fetchItemsSuccess(response.data));
        },
        (error) => {
          dispatch(fetchItemsFailure(error));
        }
      );
    },
    fetchBrands: () => {
      dispatch(fetchBrands()).payload.then(
        (response) => {
          dispatch(fetchBrandsSuccess(response.data));
        },
        (error) => {
          dispatch(fetchBrandsFailure(error));
        }
      );
    },
    fetchGrades: () => {
      dispatch(fetchGrades()).payload.then(
        (response) => {
          dispatch(fetchGradesSuccess(response.data));
        },
        (error) => {
          dispatch(fetchGradesFailure(error));
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseOrderDetailContainer));
